function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useEffect, useState } from "react";
import { giftSvg } from "../../../DealsAndDiscounts/Components/Header/svg";
import { isRewardsVisible } from "../../../../utils/routing";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var ENV = window.reloy_env.ENV || process.env.REACT_APP_ENV;
var questions = [{
  id: -1,
  question: "Why are you cashing out?",
  type: "MULTI_MCQ",
  possibleAnswers: ["Did not like the products", "I Prefer Cash", "Not getting the value from products"]
}, {
  id: -2,
  question: "If you did not find the product you are looking for, share a link and we will source it for you.",
  type: "FREE",
  optional: true
}, {
  id: -3,
  question: "Any additional feedback to help us improve?",
  type: "FREE",
  optional: true
}];
function MiniSurvey(_ref) {
  var show = _ref.show,
    setShow = _ref.setShow,
    closeKYCModal = _ref.closeKYCModal,
    showMessage = _ref.showMessage,
    setShowMessage = _ref.setShowMessage,
    bankstatus = _ref.bankstatus,
    config = _ref.config,
    winnreAuth = _ref.winnreAuth;
  var _useState = useState(["", ""]),
    _useState2 = _slicedToArray(_useState, 2),
    comments = _useState2[0],
    setComments = _useState2[1];
  var _useState3 = useState(new Array(questions[0].possibleAnswers.length).fill(false)),
    _useState4 = _slicedToArray(_useState3, 2),
    checkedState = _useState4[0],
    setCheckedState = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    formIsValid = _useState6[0],
    setFormIsValid = _useState6[1]; // Form validation
  // const [showMessage, setShowMessage] = useState(false);
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    loading = _useState8[0],
    setLoading = _useState8[1];
  var handleTextChange = function handleTextChange(event, index) {
    var updatedComments = _toConsumableArray(comments);
    updatedComments[index] = event.target.value;
    setComments(updatedComments);
  };

  // Handle MULTI_MCQ answer selection
  var handleMultiMcqClick = function handleMultiMcqClick(index) {
    var updatedCheckedState = checkedState.map(function (item, idx) {
      return idx === index ? !item : item;
    });
    setCheckedState(updatedCheckedState);
    setFormIsValid(updatedCheckedState.includes(true));
  };
  var handleSubmit = function handleSubmit() {
    // setLoading(false);
    // setShowMessage(false);
    questions.forEach(function (question, questionIndex) {
      var answer = "";
      if (question.type === "FREE") {
        answer = comments[questionIndex - 1];
      } else if (question.type === "MULTI_MCQ") {
        var _window;
        var selectedAnswers = question.possibleAnswers.filter(function (answer, index) {
          return checkedState[index];
        });
        if (selectedAnswers.length === 0) return;
        answer = selectedAnswers.join(", ");
        var attributes = {
          "Did not like the products": checkedState[0] ? "Y" : "N",
          "I Prefer Cash": checkedState[1] ? "Y" : "N",
          "Not getting the value from products": checkedState[2] ? "Y" : "N"
        };
        (_window = window) === null || _window === void 0 || (_window = _window.webengage) === null || _window === void 0 || _window.track("SurveyAnswered", attributes);
      }
      winnreAuth === null || winnreAuth === void 0 || winnreAuth({
        method: "POST",
        url: "winnre/user/mini-survey-answer/submit",
        data: {
          answer: answer,
          questionId: question.id,
          answerSource: "WEB",
          userSyncClientId: config === null || config === void 0 ? void 0 : config.id
        }
      }).then(function (res) {
        console.log("RESPONSE FROM QUESTION", res);
        if (res.status === "FAILED") {
          console.log("survey response", res);
          // setShowMessage(true);
          setShow(false);
          // setLoading(true);
          return;
        }
        if (question.type === "FREE") {
          var _window2;
          var attributeName = questionIndex === 1 ? "AdditionalProductRequest" : "CashAdditionalFeedback";
          (_window2 = window) === null || _window2 === void 0 || (_window2 = _window2.webengage) === null || _window2 === void 0 || _window2.track("SurveyAnswered", _defineProperty({}, attributeName, answer));
        }
        setShow(false);
        // console.log('Answer submitted for question:', question.id);
      })["catch"](function (error) {
        console.error("Submission error:", error);
      });
    });
  };
  // useEffect(() => {
  //     if (showMessage) {
  //         const timer = setTimeout(() => {
  //             setShowMessage(false);
  //             setLoading(false);
  //             setShow(false);
  //         }, 2000);
  //     }
  // }, [showMessage]);

  return /*#__PURE__*/_jsx(_Fragment, {
    children: show && !showMessage && /*#__PURE__*/_jsxs("div", {
      className: "pt-1 px-4 lg:px-6 flex flex-col gap-3",
      children: [questions.map(function (question, questionIndex) {
        return /*#__PURE__*/_jsxs("div", {
          children: [/*#__PURE__*/_jsx("div", {
            className: "flex flex-row gap-2",
            children: /*#__PURE__*/_jsx("h3", {
              className: "font-medium text-base lg:text-lg pr-10 p-2",
              children: question.question
            })
          }), question.type === "FREE" && /*#__PURE__*/_jsx("div", {
            className: "flex items-center h-16  rounded-lg border border-[#dddddd] p-2",
            children: /*#__PURE__*/_jsx("textarea", {
              type: "text",
              className: "text-black outline-none w-full",
              value: comments[questionIndex - 1],
              onChange: function onChange(event) {
                return handleTextChange(event, questionIndex - 1);
              }
            })
          }), question.type === "MULTI_MCQ" && /*#__PURE__*/_jsx("div", {
            className: "grid grid-cols-1 xl:grid-cols-2 gap-2 mt-2",
            children: question.possibleAnswers.map(function (answer, index) {
              return /*#__PURE__*/_jsx("div", {
                className: "cursor-pointer p-2 rounded-md border-2 ".concat(checkedState[index] ? "border-primary text-white bg-primary" : "border-gray-100"),
                onClick: function onClick() {
                  return handleMultiMcqClick(index);
                },
                children: /*#__PURE__*/_jsx("p", {
                  children: answer
                })
              }, index);
            })
          })]
        }, question.id);
      }), /*#__PURE__*/_jsx("div", {
        className: "w-full flex flex-row gap-2 mt-2 justify-start md:justify-end",
        children: /*#__PURE__*/_jsx("button", {
          className: "sub-btn px-6 text-white disabled:opacity-70 disabled:bg-gray-400 disabled:cursor-not-allowed",
          onClick: handleSubmit,
          disabled: !formIsValid,
          children: "Submit"
        })
      }), isRewardsVisible && /*#__PURE__*/_jsx("div", {
        className: "py-1",
        children: /*#__PURE__*/_jsxs("div", {
          onClick: closeKYCModal,
          className: "flex border-2 rounded-xl mt-4 cursor-pointer py-4 px-4 ",
          children: [giftSvg, /*#__PURE__*/_jsxs("div", {
            className: "ml-2",
            children: [/*#__PURE__*/_jsx("h1", {
              className: "font-semibold",
              children: "Want to claim the whole amount?"
            }), /*#__PURE__*/_jsx("p", {
              className: "text-sm",
              children: "Redeem your reward at our exclusive store"
            })]
          })]
        })
      })]
    })
  });
}
export default MiniSurvey;